import Alert from '@mui/material/Alert'
import { t } from '@lingui/core/macro'

export const PendingMessage = ({ isPending }) => {
  if (!isPending) return null
  return (
    <div style={{ marginRight: 120, marginLeft: 120 }}>
      <Alert variant="filled" severity="info">
        {t`This pending submission has errors or has been configured to not automatically submit.`}
      </Alert>
    </div>
  )
}
